// INTEGRATION-07 Daraz (owner, 2026-10-24; D-056): the shop's Daraz store managed from Adyvance.
// Our own wording.
export const darazStrings = {
  title: "Daraz",
  lead: "Your Daraz store, managed from here: orders, stock, prices and payouts.",
  tabs: {
    overview: "Overview",
    orders: "Orders",
    products: "Products",
    money: "Money",
  },
  state: {
    off: "Not connected",
    connected: "Connected",
    expired: "Sign in again",
    error: "Needs attention",
  },
  synced: "Synced {time}",
  ago: { now: "just now", minutes: "{n}m ago", hours: "{n}h ago" },
  neverSynced: "Not synced yet",
  syncNow: "Sync now",
  syncing: "Syncing…",
  synced_toast: "Syncing with Daraz. This page updates in a few seconds.",
  settings: "Settings",
  openSeller: "Open Daraz Seller Center",

  connect: {
    title: "Manage your Daraz store from Adyvance",
    body: "Connect your Daraz seller account once. Daraz orders come into Orders, your stock stays the same on your website, POS and Daraz, and Daraz payouts show in money.",
    points: {
      orders: "Daraz orders in one list with your other orders",
      stock: "One stock for website, shop and Daraz: no overselling",
      label: "Pack, print the Daraz label and hand over from here",
      money: "Daraz sales, fees and payouts at a glance",
    },
    button: "Connect Daraz",
    redirect:
      "Daraz opens in a new window. Sign in with your Daraz seller account and allow Adyvance.",
    waiting: "Waiting for Daraz",
    waitingBody: "Finish signing in on the window that opened. This updates by itself.",
    notReady:
      "Adyvance is still finishing its approval with Daraz. You can connect as soon as it's ready.",
    connected: "Daraz connected",
    how: {
      title: "How it connects",
      s1: "Click Connect Daraz. Daraz's sign-in opens in a new window.",
      s2: "Sign in with your Daraz seller account (the one you use for Seller Center).",
      s3: "Allow Adyvance to read and manage your orders and products.",
      s4: "Back here, Adyvance reads your listings and matches them to your products by SKU.",
      note: "Use the same SKU on Daraz and in Adyvance and your products link by themselves. You can still use Daraz Seller Center; changes there show here on the next sync.",
    },
  },

  overview: {
    toPack: "To pack",
    toShip: "Ready to hand over",
    today: "Orders today",
    sales: "Sales, 30 days",
    ordersCount: "{count} orders",
    attention: "Needs packing",
    attentionEmpty: "Nothing to pack. Nice work!",
    stock: "Stock sync",
    stockLinked: "{linked} of {total} listings follow your stock",
    stockOff: "Stock sync is off",
    outOfSync: "{count} listings will update on the next sync",
    allInSync: "Every linked listing matches your stock",
    noneLinked: "No listing is linked yet, so Daraz keeps its own stock. Link them to sync.",
    linkProducts: "Link products",
    recent: "Latest Daraz orders",
    seeAll: "See all",
  },

  orders: {
    search: "Search order number or customer",
    status: {
      all: "All",
      unpaid: "Unpaid",
      pending: "To pack",
      packed: "Packed",
      ready_to_ship: "Ready to ship",
      shipped: "Shipped",
      delivered: "Delivered",
      canceled: "Cancelled",
      returned: "Returned",
      failed: "Failed",
    },
    columns: {
      order: "Order",
      customer: "Customer",
      items: "Items",
      total: "Total",
      status: "Status",
      adyvance: "In Adyvance",
      actions: "Actions",
    },
    itemsCount: "{count} items",
    itemsOne: "1 item",
    pack: "Pack",
    label: "Print label",
    rts: "Ready to ship",
    packSelected: "Pack selected",
    rtsSelected: "Ready to ship",
    labelSelected: "Print labels",
    packed: "Packed on Daraz",
    readyDone: "Marked ready to ship",
    labelReady: "Label ready",
    notImported: "Not in Orders",
    notImportedHelp: "Link its products by SKU to bring it into Orders.",
    empty: "No Daraz orders here.",
    cod: "Cash on delivery",
    selected: "{count} selected",
    clear: "Clear",
    tracking: "Tracking {code}",
  },

  products: {
    search: "Search name or SKU",
    filter: {
      all: "All",
      linked: "Linked",
      unlinked: "Not linked",
      out_of_sync: "Will update",
    },
    columns: {
      product: "Daraz listing",
      daraz: "On Daraz",
      adyvance: "Adyvance product",
      stock: "Stock",
      actions: "Actions",
    },
    // Owner comment c9 (2026-11-04): says where the Daraz listing is linked to.
    link: "Link to Website",
    relink: "Change",
    unlink: "Unlink",
    linked: "Linked",
    unlinked: "Unlinked",
    pickTitle: "Link to an Adyvance product",
    pickSearch: "Search your products",
    noMatch: "No product matches.",
    createTitle: "Not in Adyvance yet?",
    createHelp:
      "Creates a draft product with this listing's name, price, SKU and stock, then links it. Add photos and publish it when you are ready.",
    createButton: "Create in Adyvance",
    created: "Created “{name}” as a draft and linked it to Daraz.",
    willSend: "Daraz will get {qty}",
    inSync: "In sync",
    stockLabel: "{qty} in stock",
    pushNow: "Send stock now",
    pushed: "Sent to Daraz",
    empty: "No Daraz listings yet. They show here after the first sync.",
    sku: "SKU {sku}",
    notLinkedHelp: "Not linked: Daraz keeps its own stock for this listing.",
  },

  // List on Daraz (D-095).
  list: {
    button: "List on Daraz",
    title: "List a product on Daraz",
    pickProduct: "Pick a product",
    variantCount: { one: "{count} variant", other: "{count} variants" },
    secListing: "Listing",
    changeProduct: "Change product",
    priceOnDaraz: "Price on Daraz",
    setHere: "Set here",
    pcs: "pcs",
    typeToSearch: "Type to search",
    linesHint: "One point per line",
    checklist: "Ready to send",
    check: {
      photos: { one: "{count} photo and a description", other: "{count} photos and a description" },
      category: "Daraz category",
      details: "Details {done} of {total}",
      variants: "SKU and price",
      package: "Package size and weight",
    },
    searchProducts: "Search your products",
    noProducts: "No product matches.",
    change: "Change",
    nameOnDaraz: "Title on Daraz",
    category: "Daraz category",
    categorySearch: "Search Daraz categories",
    suggested: "Suggested",
    noCategory: "No category matches. Try another word.",
    searchHint: "Type what the product is, like “cap”, “saree” or “blender”.",
    brand: "Brand",
    brandHelp: "Use “No Brand” unless the brand is registered on Daraz.",
    details: "Details Daraz asks for",
    moreDetails: "More details, optional ({count})",
    loadingDetails: "Reading what this category needs…",
    choose: "Choose",
    multiHelp: "Separate values with commas.",
    variants: "Variants",
    sellerSku: "Seller SKU",
    price: "Price on Daraz",
    stock: "Stock",
    followsStock: "Follows Adyvance",
    package: "Package",
    weight: "Weight (kg)",
    length: "Length (cm)",
    width: "Width (cm)",
    height: "Height (cm)",
    inBox: "What's in the box",
    inBoxDefault: "1 x {name}",
    photos: "Photos",
    photosHelp: "Up to 8 of the product's photos go to Daraz as JPG.",
    noPhotos: "Add a photo to this product first. Daraz needs at least one.",
    noDescription: "Add a description to this product first. Daraz needs one.",
    required: "Fill in {field}.",
    skuRule: "Seller SKUs can use letters, numbers, “-”, “_” and “.” only.",
    uploading: "Sending photos {done} of {total}…",
    creating: "Creating the listing…",
    submit: "Send to Daraz",
    qcNote:
      "Daraz checks every new listing before it goes live, usually within 1–2 days. It stays linked here, so stock follows Adyvance.",
    priceNote: "Price sync is on: Daraz will get the Adyvance price plus your markup.",
    created: "Sent to Daraz. It shows as “Waiting for Daraz check” until Daraz approves it.",
    photoFailed: "A photo couldn't be prepared for Daraz. Try a different photo.",
    pending: "Waiting for Daraz check",
  },

  money: {
    summary: "Statements",
    sales: "Sales",
    fees: "Fees",
    net: "You get",
    paid: "Paid",
    unpaid: "Not paid yet",
    transactions: "Transactions",
    columns: {
      date: "Date",
      type: "Type",
      order: "Order",
      amount: "Amount",
      statement: "Statement",
    },
    empty: "No Daraz statements yet.",
    note: "From Daraz's finance reports. Daraz pays out on its own schedule.",
  },

  settingsPopup: {
    title: "Daraz settings",
    importOrders: "Bring Daraz orders into Orders",
    importOrdersHelp:
      "They reserve stock like any order, so your website and POS never sell the same unit.",
    syncStock: "Send my stock to Daraz",
    syncStockHelp: "Linked listings get your available stock every 10 minutes.",
    buffer: "Keep back from Daraz",
    bufferHelp: "Units Daraz never sees, for walk-in and website sales.",
    syncPrice: "Send my prices to Daraz",
    syncPriceHelp: "Off: you set Daraz prices in Seller Center.",
    markup: "Add on Daraz (%)",
    markupHelp: "Covers Daraz's commission. Rs 1,000 with 10% shows Rs 1,100 on Daraz.",
    save: "Save",
    saved: "Daraz settings saved",
    disconnect: "Disconnect Daraz",
    disconnectConfirm:
      "Disconnect Daraz? Orders and stock stop syncing. Orders already in Adyvance stay.",
    disconnected: "Daraz disconnected",
    cancel: "Cancel",
    account: "Daraz account",
  },
} as const;
